import { characters } from "@/mocks/comicData";

const charImages = [
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20character%20portrait%20of%20a%20handsome%20young%20male%20immortal%20doctor%20in%20robes%20holding%20a%20needle%2C%20jade%20green%20and%20cinnabar%20red%20tones%2C%20elegant%20traditional%20style&width=700&height=900&seq=char-01-001&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20character%20portrait%20of%20a%20graceful%20young%20female%20herbalist%20in%20elegant%20robes%2C%20jade%20green%20tones%2C%20elegant%20traditional%20style&width=700&height=900&seq=char-02-001&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20character%20portrait%20of%20a%20rugged%20loyal%20swordsman%20in%20dark%20robes%20with%20a%20sword%2C%20cinnabar%20red%20accents%2C%20elegant%20traditional%20style&width=700&height=900&seq=char-03-001&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20character%20portrait%20of%20a%20wise%20elderly%20medical%20master%20with%20white%20hair%20and%20long%20beard%2C%20jade%20green%20and%20gold%20tones%2C%20elegant%20traditional%20style&width=700&height=900&seq=char-04-001&orientation=portrait",
];

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
            <i className="ri-group-line"></i>主要角色
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            认识故事中的主角们
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            医仙沈星澜与同路知己，在药谷试炼与医仙大会中并肩成长，共同书写济世传奇。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((c, i) => (
            <article key={c.name} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="h-52 overflow-hidden">
                <img
                  src={charImages[i]}
                  alt={`天才医仙角色${c.name}`}
                  title={`天才医仙漫画 ${c.name}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-0.5 text-xs text-accent-600">{c.alias}</p>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}